import app from 'flarum/forum/app';
import rukoCompat from './compat';
import { compat } from '@flarum/core/forum';
import extensionsManage from './extensions-manage/index';
import newExtensions from './new-extensions/index';
import ProductListState from '../common/states/ProductListState';

export { default as extend } from './extend';

Object.assign(compat, rukoCompat);

app.initializers.add('acme-ruko', () => {
  app.productList = new ProductListState();

  extensionsManage();
  newExtensions();
});
